// TermsOfService.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import Privacy from '../component/Privacy.jsx';

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
  };
};

export default connect(null, mapDispatchToProps)(Privacy);
